import { render } from "./PictureInput.vue?vue&type=template&id=4b637e7d&scoped=true"
import script from "./PictureInput.vue?vue&type=script&lang=js"
export * from "./PictureInput.vue?vue&type=script&lang=js"

import "./PictureInput.vue?vue&type=style&index=0&id=4b637e7d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b637e7d"]])

export default __exports__